"use client";

import { ChartBar as BarChart3, Settings, ShieldCheck, Target, Users, Zap } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Services() {
  const header = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.2
  });
  const services = [{
    code: "[ R-01 ]",
    title: "OTA Revenue Management",
    description: "Maximize your visibility and conversion rates on major platforms with data-backed listing optimization and dynamic inventory control.",
    Icon: Target
  }, {
    code: "[ R-02 ]",
    title: "Hospitality Tech Implementation",
    description: "Seamlessly integrate modern tech stacks, from channel managers to booking engines, to streamline your operations and boost efficiency.",
    Icon: Settings
  }, {
    code: "[ R-03 ]",
    title: "Revenue Audits",
    description: "Comprehensive performance reviews to identify hidden revenue leaks and unlock untapped growth potential in your property's pricing strategy.",
    Icon: BarChart3
  }, {
    code: "[ R-04 ]",
    title: "Direct Booking Growth",
    description: "Strategic digital marketing and website optimization to shift bookings from high-commission OTAs to your own direct channels.",
    Icon: Zap
  }, {
    code: "[ R-05 ]",
    title: "Rate Parity Monitoring",
    description: "Proactive tracking and correction of rate discrepancies across all distribution channels to protect your brand integrity and margins.",
    Icon: ShieldCheck
  }, {
    code: "[ R-06 ]",
    title: "Remote Revenue Management",
    description: "Expert, hands-on revenue management support tailored to your hotel's unique market position and demand cycles.",
    Icon: Users
  }];
  return <section data-section-id="994" id="servicenavigationgrid" className="bg-background text-foreground py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {}
        <div ref={header.ref} className={`grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16 transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div>
            <p className="font-mono text-xs tracking-widest text-muted-foreground uppercase mb-6">
              [ 01 &mdash; OUR SERVICES ]
            </p>
            <h2 className="font-serif font-default text-foreground leading-[1.05] tracking-tight" style={{
            fontSize: "clamp(2.5rem, 5vw, 4rem)"
          }}>
              Driving revenue through{" "}
              <em className="italic font-serif text-secondary">strategic insight.</em>
            </h2>
          </div>
          <div className="flex flex-col justify-end gap-6">
            <p className="text-base lg:text-lg text-muted-foreground leading-relaxed max-w-md">
              We provide data-driven revenue management solutions designed to help hotel owners and managers maximize profitability and streamline distribution.
            </p>
            <Link to="/OurServicesPage" className="group inline-flex items-center gap-2 font-mono text-sm text-foreground hover:text-secondary transition-colors w-fit">
              <span className="border-b border-foreground/30 group-hover:border-secondary pb-0.5">
                Explore all services
              </span>
              <span className="transition-transform group-hover:translate-x-1">
                &rarr;
              </span>
            </Link>
          </div>
        </div>

        {}
        <div className="mt-20 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {services.map((service, i) => {
          const Icon = service.Icon;
          return <div key={i} data-index={i} className="group relative flex flex-col bg-card border border-border rounded-lg p-10 transition-all duration-300 hover:border-secondary overflow-hidden shadow-md">
                {}
                <div className="mb-10">
                  <Icon className="text-secondary transition-transform duration-300 group-hover:scale-105" strokeWidth={1} style={{
                width: "64px",
                height: "64px"
              }} />
                </div>

                {}
                <p className="font-mono text-xs tracking-widest text-muted-foreground uppercase mb-4">
                  {service.code}
                </p>

                {}
                <h3 className="font-serif font-default text-2xl text-card-foreground leading-tight mb-4">
                  {service.title}
                </h3>

                {}
                <p className="font-default text-[15px] leading-relaxed text-muted-foreground mb-8">
                  {service.description}
                </p>

                {}
                <div className="mt-auto pt-6 border-t border-border">
                  <Link to="/OurServicesPage" className="inline-flex items-center gap-1.5 font-mono text-xs text-secondary hover:gap-2.5 transition-all">
                    <span>Learn more</span>
                    <span>&rarr;</span>
                  </Link>
                </div>

                {}
                <span className="absolute bottom-0 left-0 h-px w-0 group-hover:w-full transition-all duration-500 ease-out" style={{
              backgroundColor: "var(--secondary)"
            }} aria-hidden="true" />
              </div>;
        })}
        </div>

        {}
        <div className="mt-12 flex justify-center lg:hidden">
          <Button asChild variant="outline" size="lg" className="font-mono text-sm bg-secondary text-white border-none rounded-lg">
            <Link to="/OurServicesPage">View all services &rarr;</Link>
          </Button>
        </div>
      </div>
    </section>;
}